import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Chatbot from "../Bot/Chatbot";

const HIDE_SIDEBAR_ON = [
  "/feedback/feedback-integrations",
  "/feedback/feedback-integrations/setup",
];

const Sidebar = () => {
  const location = useLocation();
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  const hideSidebar = HIDE_SIDEBAR_ON.some((p) =>
    location.pathname.startsWith(p)
  );

  const toggleChatbot = () => setIsChatbotOpen((prev) => !prev);

  if (hideSidebar) {
    return <Chatbot isOpen={isChatbotOpen} toggleChatbot={toggleChatbot} />;
  }

  // return your original sidebar UI here for other pages
  return (
    <>
      {/* Original sidebar markup */}
      <Chatbot isOpen={isChatbotOpen} toggleChatbot={toggleChatbot} />
    </>
  );
};

export default Sidebar;